import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { fromEvent } from 'rxjs';
import { Menu, NavService } from '../../services/nav.service';
import { checkHoriMenu, parentNavActive, switcherArrowFn } from './sidemenu';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TokenStorageService } from '../../services/token-storage.service';

const SUPERADMIN_ALLOWED_TITLES = [
  // 'Dashboard',
  // 'Circuit',
  // 'Ticket',
  // 'Pending Bills',
  // 'Feasibility',
  'Select Customer'
];

const EXCLUDED_FOR_OTHERS_TITLES = [
  'Select Customer'   // or 'Customer Portal', adjust exact title
];

@Component({
  selector: 'app-sidemenu',
  templateUrl: './sidemenu.component.html',
  styleUrls: ['./sidemenu.component.scss'],
  standalone: false
})


export class SidemenuComponent implements OnInit {
  public menuItems!: Menu[];
  public url: any;
  open = 'open';
  public windowSubscribe$!: any;
  currentUserDetail: any

  constructor(
    private router: Router,
    private navServices: NavService,
    public elRef: ElementRef,
    private sanitizer: DomSanitizer,
    public elementRef: ElementRef,
    public renderer: Renderer2,
    private breakpointObserver: BreakpointObserver,
    private tks: TokenStorageService
  ) {
    this.checkNavActiveOnLoad();
  }

  options = { autoHide: false, scrollbarMinSize: 100 };

  // To set Active on Load
  checkNavActiveOnLoad() {
    this.currentUserDetail = JSON.parse(localStorage.getItem('currentUser') as string) || '';
    this.navServices.items.subscribe((menuItems: any) => {
      this.menuItems = menuItems;

      if (this.currentUserDetail.officeType === 'SuperAdmin' && !(this.tks.getCompanyToken())) {
        this.menuItems = menuItems.filter((item: { title: string; }) =>
          SUPERADMIN_ALLOWED_TITLES.includes(item.title)
        );
        this.router.navigate(['/customer-portal/select-customer'])
      } else {
        if (this.currentUserDetail.officeType === 'SuperAdmin' && this.tks.getCompanyToken()) {
          this.menuItems = menuItems;
        } else {
          this.menuItems = menuItems.filter((item: { title: string; }) =>
            !EXCLUDED_FOR_OTHERS_TITLES.includes(item.title)
          );
        }

      }

      this.router.events.subscribe((event: any) => {
        if (event instanceof NavigationStart) {
          let path = location.pathname.split('/');
          let eventUrl = event.url.split('/');
          if (path[path.length - 2] !== eventUrl[eventUrl.length - 2]) {
            this.closeNavActive();

            let sidemenuul = document.querySelectorAll(
              '.nav-sub-link.sub-with-sub'
            );
            let subSidemenuUl = document.querySelector('.nav-item.active');
            let subSidemenu = document.querySelectorAll(
              '.nav-sub-link.sub-with-sub'
            );

          }
        }
        if (event instanceof NavigationEnd) {
          menuItems.filter((items: any) => {
            if (items.path === event.url) {
              this.setNavActive(items);
            }
            if (!items.children) {
              return false;
            }
            items.children.filter((subItems: any) => {
              if (subItems.path === event.url) {
                this.setNavActive(subItems);
              }
              if (!subItems.children) {
                return false;
              }
              subItems.children.filter((subSubItems: any) => {
                if (subSubItems.path === event.url) {
                  this.setNavActive(subSubItems);
                }
                if (!subSubItems.children) {
                  return false;
                }
                subSubItems?.children.filter((subSubItems1: any) => {
                  if (subSubItems1.path === event.url) {
                    this.setNavActive(subSubItems1);
                  }
                  if (!subSubItems1.children) {
                    return false;
                  }
                  return;
                });
                return;
              });
              return;
            });
            return;
          });
        }
      });
    });
  }

  checkCurrentActive() {
    this.navServices.items.subscribe((menuItems: any) => {
      this.menuItems = menuItems;
      let currentUrl = this.router.url;
      menuItems.filter((items: any) => {
        if (items.path === currentUrl) {
          this.setNavActive(items);
        }
        if (!items.children) {
          return false;
        }
        items.children.filter((subItems: any) => {
          if (subItems.path === currentUrl) {
            this.setNavActive(subItems);
          }
          if (!subItems.children) {
            return false;
          }
          subItems.children.filter((subSubItems: any) => {
            if (subSubItems.path === currentUrl) {
              this.setNavActive(subSubItems);
            }
          });
          return;
        });
        return;
      });
    });
  }
  //Active Nav State
  setNavActive(item: Menu) {
    this.menuItems.filter((menuItem) => {
      if (menuItem !== item) {
        menuItem.active = false;
        this.navServices.collapseSidebar = false;
      }
      if (menuItem.children && menuItem.children.includes(item)) {
        menuItem.active = true;
      }
      if (menuItem.children) {
        menuItem.children.filter((submenuItems) => {
          if (submenuItems.children && submenuItems.children.includes(item)) {
            menuItem.active = true;
            submenuItems.active = true;
          }
          if (submenuItems.children) {
            submenuItems.children.forEach((subsubmenuItems) => {
              if (
                subsubmenuItems.children &&
                subsubmenuItems.children.includes(item)
              ) {
                menuItem.active = true;
                submenuItems.active = true;
                subsubmenuItems.active = true;
              }
            });
          }
        });
      }
    });
  }

  // Toggle menu
  toggleNavActive(item: any) {
    // this.menuItem.active = !this.menuItem.active;
    if (localStorage.getItem('valexverticalstyles') == 'icontext') {
      document.querySelector('html')?.setAttribute('data-icon-text', 'open')
    } else {
      document.querySelector('html')?.removeAttribute('data-icon-text')
    }

    if (!item.active) {
      this.menuItems.forEach((a: any) => {
        if (this.menuItems.includes(item)) {
          a.active = false;
        }
        if (!a.children) {
          return false;
        }
        a.children.forEach((b: any) => {
          if (a.children.includes(item)) {
            b.active = false;
          }
          if (!b.children) {
            return false;
          }
          b.children.forEach((c: any) => {
            if (b.children.includes(item)) {
              c.active = false;
            }
            if (!c.children) {
              return false;
            }
            return;
          });
          return;
        });
        return;
      });
    }
    item.active = !item.active;
  }

  ParentActive() {
    this.menuItems.map((element: any) => {
      if (element.children) {
        element.active = false;
        element.selected = false;
        element.children.map((ele: any) => {
          if (ele.path == this.router.url) {
            element.active = true;
            element.selected = true;
          }
          if (ele.children) {
            ele.active = false;
            ele.children.map((child1: any) => {
              if (child1.path == this.router.url) {
                element.active = true;
                element.selected = true;
                ele.active = true;
              }
            });
          }
        });
      }
    });
  }

  // Close Nav menu
  closeNavActive() {
    this.menuItems.forEach((a: any) => {
      if (this.menuItems) {
        a.active = false;
      }
      if (!a.children) {
        return false;
      }
      a.children.forEach((b: any) => {
        if (a.children) {
          b.active = false;
        }
      });
      return;
    });
  }

  ngOnInit(): void {
    let bodyElement: any = document.querySelector('.main-content');

    bodyElement.onclick = () => {
      if (
        localStorage.getItem('valexnavstyles') == 'icon-click' ||
        localStorage.getItem('valexnavstyles') == 'menu-click' ||
        localStorage.getItem('valexnavstyles') == 'icon-hover' ||
        localStorage.getItem('valexlayout') == 'horizontal'
      ) {
        document
          .querySelectorAll('.main-menu .slide-menu.child1')
          .forEach((ele: any) => {
            ele.style.display = 'none';
          });
      }

      if (localStorage.getItem('valexverticalstyles') == 'icontext') {
        document.querySelector('html')?.removeAttribute('data-icon-text')
      }
    };

    if (localStorage.getItem('valexlayout') == 'horizontal') {
      document.querySelector('.slide-menu')?.setAttribute('style', 'display: none;');
    } else {
      document.querySelector('.slide-menu')?.setAttribute('style', 'display: block;');
    }


    this.ParentActive();
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.ParentActive();
      }
    });
    switcherArrowFn();

    fromEvent(window, 'resize').subscribe(() => {
      if (window.innerWidth >= 992) {
        document
          .querySelector('body.horizontal')
          ?.classList.remove('sidenav-toggled');
      }
      if (
        document
          .querySelector('body')
          ?.classList.contains('horizontal-hover') &&
        window.innerWidth > 992
      ) {
        let li = document.querySelectorAll('.main-menu li');
        li.forEach((e, i) => {
          e.classList.remove('open');
        });
        let ul = document.querySelectorAll('.main-menu ul');
        li.forEach((e, i) => {
          e.classList.remove('open');
        });
      }
    });

    // detect screen size changes
    this.breakpointObserver
      .observe(['(max-width: 991.98px)'])
      .subscribe((result: BreakpointState) => {
        if (result.matches) {
          // small screen
          this.checkCurrentActive();
        } else {
          // large screen
          document
            .querySelector('body.horizontal')
            ?.classList.remove('sidenav-toggled');
          if (document.querySelector('.horizontal:not(.horizontal-hover)')) {
            this.closeNavActive();
            setTimeout(() => {
              parentNavActive();
            }, 100);
          }
        }
      });

    let vertical: any = document.querySelectorAll('#switcher-vertical');
    let horizontal: any = document.querySelectorAll('#switcher-horizontal');
    fromEvent(vertical, 'click').subscribe(() => {
      this.checkCurrentActive();
    });
    fromEvent(horizontal, 'click').subscribe(() => {
      this.closeNavActive();
    });


    const WindowResize = fromEvent(window, 'resize');
    // subscribing the Observable
    this.windowSubscribe$ = WindowResize.subscribe(() => {
      checkHoriMenu();
    });

    checkHoriMenu();
    if (
      document.documentElement.getAttribute('data-nav-layout') ==
      'horizontal' &&
      window.innerWidth > 992
    ) {
      this.closeNavActive();
    }

    let maincontent: any = document.querySelectorAll('.main-content');
    fromEvent(maincontent, 'click').subscribe(() => {
      if (
        document
          .querySelector('data-nav-layout')
          ?.classList.contains('horizontal')
      ) {
        this.closeNavActive();

        setTimeout(() => {
          parentNavActive();
        }, 100);
      }
    });
  }

  scrolled: boolean = false;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.scrolled = window.scrollY > 64;
  }

  ngOnDestroy() {
    // unsubscribing the Observable
    this.windowSubscribe$.unsubscribe();
  }

  @ViewChild('iconContainer', { static: true }) iconContainer!: ElementRef;
  getSanitizedSVG(icon: string): SafeHtml {
    const sanitizedIcon = this.sanitizer.bypassSecurityTrustHtml(icon);
    return sanitizedIcon;
  }

}
